import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";
import AgGridPaginatedTable from "../../components/AgGridPaginatedTable";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { Box, Typography, Button, Paper, TextField, Grid } from "@mui/material";
import useErrorHandler from "../../hooks/useErrorHandler";
import { SalesOrdheaderTable } from "../../config/reactfile.js";
import { useParams } from "react-router-dom";
import {
  getReports,
  getreportsDownloadExport,
  getSubsidiaryOption,
} from "../../api/reports.js";
import { ReportsTable } from "../../config/grid-column-defs.js";
import DownloadIcon from "@mui/icons-material/Download";
import DownloadDialog from "../../components/DownloadDialogComp.jsx";
export default function ReportsList() {
  const [pageName, setPageName] = useState("Journal");
  const [sectionName, setSectionName] = useState("lines");
  const dispatch = useDispatch();
  const errorHandler = useErrorHandler();
  const [anchorEl, setAnchorEl] = useState(null);
  const open1 = Boolean(anchorEl);
  const snackbar = useSnackbar();
  const params = useParams();
  const { data: user } = useSelector((state) => state.user);
  const [tableRefreshCount, setTableRefreshCount] = useState(0);

  const [pageNameListData, setPageNameDataList] = useState([]);
  const [sectionNameListData, setsectionNameDataList] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const dialogAction = useSelector((state) => state.dialog);
  const [downloadInProgress, setDownloadInProgress] = useState(false);
  const [percentComplete, setPercentComplete] = useState(0);
  const [nameSearchInputValue, setNameSearchValue] = useState("");

  function refreshTable() {
    setTableRefreshCount((prev) => prev + 1);
  }
  let obj = ReportsTable.find((o) => o.headerName === "DOWNLOAD");
  addAdditionalColumnDownload(obj, dispatch);

  const getDownloadDocumentById = (reportName) => {
    setPercentComplete(0);

    const options = {
      headers: {
        authorization: user?.token,
      },
      responseType: "blob",
      onDownloadProgress: function (progressEvent) {
        const newPercentComplete = Math.floor(
          (progressEvent.loaded / progressEvent.total) * 100
        );
        setPercentComplete(newPercentComplete); // Update the percentComplete state
      },
    };
    setDownloadInProgress(true); // Start the download progress
    getreportsDownloadExport(
      { limit: "", offset: 0, report_name: reportName, file: "xlsx" },
      options
    )
      .then((blob) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob.data);
        link.setAttribute("download", `${reportName}`);
        document.body.appendChild(link);
        link.click();
        setDialogOpen(false);
        setDownloadInProgress(false);
      })
      .catch((err) => {
        errorHandler(err);
        setDownloadInProgress(false);
        setDialogOpen(false);
      })
      .finally(() => {
        setDownloadInProgress(false);
        setDialogOpen(false);
        // Download completed or errored, stop progress
      });
  };

  useEffect(() => {
    if (!dialogAction.type) return;
    switch (dialogAction.type) {
      case "DOWNLOADVIEW":
        dispatch({ type: "" });
        setDialogOpen(true);
        getDownloadDocumentById(dialogAction?.data.table_name);
        break;

      default:
        break;
    }
  }, [dialogAction]);
  //get table data//
  async function getReportsListData(limit, offset) {
    try {
      const { data } = await getReports(user?.token, {
        limit,
        offset,
        type: "report",
        report_name: nameSearchInputValue,
      });
      return {
        rows: data.data,
        total: data.total,
        error: false,
      };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      // setLoading(false)
    }
  }
  // async function getPageNameList() {
  //   try {
  //     const { data } = await getPageNameData(user.token, {});
  //     setPageNameDataList(data.data.pageList);
  //   } catch (error) {
  //     errorHandler(error);
  //   } finally {
  //     // setLoading(false)
  //   }
  // }
  // async function getSectionNameList() {
  //   try {
  //     const { data } = await getSectionNameData(user.token, {});
  //     setsectionNameDataList(data.data.sectionList);
  //   } catch (error) {
  //     errorHandler(error);
  //   } finally {
  //     // setLoading(false)
  //   }
  // }
  // useEffect(() => {
  //   getPageNameList();
  //   getSectionNameList();
  // }, []);

  useEffect(() => {
    refreshTable();
  }, [pageName, sectionName]);
  const onNameInputSearch = (event) => {
    setNameSearchValue(event.target.value);
    refreshTable();
  };
  const handleReset = (e) => {
    setNameSearchValue("");
    refreshTable();
  };
  return (
    <>
      <Box className="viewBox">
        <Box className="viewDetilsBox">
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            pb={2}
          >
            <Typography
              component="h5"
              fontWeight={500}
              className="pageHeading1"
            >
              Reports
            </Typography>
            {/* <Button
          className="backBtn"
          onClick={() => {
            window.location.reload(); // Perform hard refresh after API call
          }}
        >
          Get latest column names
        </Button> */}
          </Box>

          <Box className="filter-box">
            <Grid container>
              <Grid item md={3} sm={4} xs={10}>
                <TextField
                  autoComplete="off"
                  placeholder={"Search Report Name"}
                  size="small"
                  label=""
                  name={"name"}
                  variant="outlined"
                  value={nameSearchInputValue}
                  onChange={onNameInputSearch}
                  fullWidth
                />
              </Grid>
              {nameSearchInputValue && (
                <Grid item md={2} sm={2} xs={2} style={{ margin: "0px 10px" }}>
                  <Button
                    size="small"
                    type="button"
                    style={{ color: "black", marginTop: "4px" }}
                    onClick={(e) => handleReset(e)}
                  >
                    Reset
                  </Button>
                </Grid>
              )}
            </Grid>
          </Box>
          <br />
          <Paper elevation={3}>
            <AgGridPaginatedTable
              getTableRows={getReportsListData}
              columns={ReportsTable}
              perPage={10}
              refreshCounter={tableRefreshCount}
            />
          </Paper>
          <DownloadDialog
            open={dialogOpen}
            onClose={() => setDialogOpen(false)}
            downloadInProgress={downloadInProgress}
            percentComplete={percentComplete}
          />
        </Box>
      </Box>
    </>
  );
}
function addAdditionalColumn(obj, dispatch) {
  if (obj === undefined) {
    SalesOrdheaderTable.unshift({
      headerName: "Action",
      field: "actions",
      maxWidth: 86,
      cellRendererFramework: (params) => (
        <Box>
          <Button
            className="actionIcon"
            onClick={() => {
              dispatch({ type: "DIALOG", data: params.data });
            }}
          >
            <EditOutlinedIcon />
          </Button>
        </Box>
      ),
    });
  }
}

function addAdditionalColumnDownload(obj, dispatch) {
  if (obj === undefined) {
    ReportsTable.unshift({
      headerName: "DOWNLOAD",
      field: "actions",
      maxWidth: 100,
      cellClass: "downloadCenter",
      cellRendererFramework: (params) => (
        <Box>
          <Button
            title="Export CSV"
            className="actionIcon"
            onClick={() => {
              dispatch({ type: "DOWNLOADVIEW", data: params.data });
            }}
          >
            <DownloadIcon />
          </Button>
        </Box>
      ),
    });
  }
}

// import React, { useState, useEffect } from "react";
// import { AgGridReact } from "ag-grid-react";
// import "ag-grid-community/styles/ag-grid.css";
// import "ag-grid-community/styles/ag-theme-alpine.css";
// import { getReports } from "../../api/reports.js";
// import {
//   ReportsTable,
//   transactionTypeDetailSalesOrder,
// } from "../../config/grid-column-defs";
// import { useSelector } from "react-redux";

// const ReportsList = () => {
//   const [rowData, setRowData] = useState([]);
//   const [totalRecords, setTotalRecords] = useState(0);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [jumpToPage, setJumpToPage] = useState("");
//   const pageSize = 20; // Number of records per page
//   const { data: user } = useSelector((state) => state.user);
//   useEffect(() => {
//     fetchData();
//   }, [currentPage]); // Fetch data whenever currentPage changes

//   const fetchData = async () => {
//     // Calculate offset based on currentPage
//     const offset = (currentPage - 1) * pageSize;

//     // Fetch data from the server using appropriate limit and offset
//     // Replace this with your actual API call
//     const response = await fetch(
//       `https://erp-qrm-dev.vastedge.com/api/transactionTypesfilter?type=SalesOrd&limit=${pageSize}&offset=${offset}`,
//       {
//         headers: {
//           authorization: user.token,
//         },
//       }
//     );
//     const data = await response.json();

//     setRowData(data.data);
//     setTotalRecords(data.total);
//   };

//   const onPageChange = (newPage) => {
//     setCurrentPage(newPage);
//   };

//   const onJumpToPageChange = (e) => {
//     setJumpToPage(e.target.value);
//   };

//   const jumpToPageHandler = () => {
//     const pageNumber = parseInt(jumpToPage);
//     if (
//       !isNaN(pageNumber) &&
//       pageNumber >= 1 &&
//       pageNumber <= Math.ceil(totalRecords / pageSize)
//     ) {
//       setCurrentPage(pageNumber);
//       setJumpToPage("");
//     } else {
//       // Handle invalid page number input
//       console.error("Invalid page number input");
//     }
//   };

//   const totalPages = Math.ceil(totalRecords / pageSize);

//   const paginationLabel = `Showing ${
//     (currentPage - 1) * pageSize + 1
//   } to ${Math.min(
//     currentPage * pageSize,
//     totalRecords
//   )} of ${totalRecords} records`;

//   return (
//     <div aria-live="polite" aria-busy={false} className="ag-theme-material">
//       <AgGridReact
//         domLayout="autoHeight"
//         rowData={rowData}
//         columnDefs={transactionTypeDetailSalesOrder} // Your column definitions
//         pagination={true}
//         paginationPageSize={pageSize}
//       />
//       <div>
//         <span>{paginationLabel}</span>
//         <button onClick={() => onPageChange(1)} disabled={currentPage === 1}>
//           First
//         </button>
//         <button
//           onClick={() => onPageChange(currentPage - 1)}
//           disabled={currentPage === 1}
//         >
//           Prev
//         </button>
//         <button
//           onClick={() => onPageChange(currentPage + 1)}
//           disabled={currentPage === totalPages}
//         >
//           Next
//         </button>
//         <button
//           onClick={() => onPageChange(totalPages)}
//           disabled={currentPage === totalPages}
//         >
//           Last
//         </button>
//       </div>
//       <div>
//         <input type="text" value={jumpToPage} onChange={onJumpToPageChange} />
//         <button onClick={jumpToPageHandler}>Go</button>
//       </div>
//     </div>
//   );
// };

// export default ReportsList;
